import React from 'react';
import { FaChartBar, FaUsers, FaCalendarAlt, FaGlobe } from 'react-icons/fa';
import StatsCard from './StatsCard';

const ShortLinkStats = ({ analytics }) => {
  const totalClicks = analytics?.totalClicks || 0;
  const uniqueClicks = analytics?.uniqueClicks || 0;
  const dailyAverage = analytics?.dailyAverage || 0;
  const differentCountries = analytics?.countries?.length || 0;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      <StatsCard
        title="Total Clicks"
        value={totalClicks}
        icon={FaChartBar}
      />
      
      <StatsCard
        title="Unique Clicks"
        value={uniqueClicks}
        icon={FaUsers}
      />
      
      <StatsCard
        title="Daily Average"
        value={dailyAverage}
        icon={FaCalendarAlt}
      />
      
      <StatsCard
        title="Different Countries"
        value={differentCountries}
        icon={FaGlobe}
      />
    </div>
  );
};

export default ShortLinkStats;
